import Carousel from "react-multi-carousel";
import { TEMPLE_CARD_CAUROSAL_RESPONSIVE } from "../../../utils/Constants"
import { Box, Typography, Button, Stack, Badge, } from "@mui/material";
import {ArrowDownward as ArrowDownwardIcon} from '@mui/icons-material';
import { Link } from "react-router-dom";
import "../../../Views/Temple/ShaktipethaView.scss";
import ReadMoreReadLess from "../../ReadMoreReadLess/ReadMoreReadLess";
import { LOCALIZATION } from "../../../utils/localization";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export default function ShaktipeethaDetailsCard(props: any) {
const { t } = useTranslation();
  return (
    <Box
      key={props.id}
      className="shaktipethaTemple">
      <Box className="shaktipethaTop">
        {/* <Box className="shaktipethaProfile">
          <img src={props.templeImage} alt="" />
        </Box> */}
        <Box className="shaktipethaTitle">
          <Typography>
            {props.templeName}{" "}
            {/* {props.verificationStatus === "VERRIFIED" ? (
              <img src={verifytick} alt="" />
            ) : null} */}
            {/* <img src={verifytick} alt="" /> */}
          </Typography>
        </Box>
      </Box>
      <Box className="shaktipethaImage">
        <Carousel
          responsive={TEMPLE_CARD_CAUROSAL_RESPONSIVE}
          swipeable={true}
          draggable={true}
          showDots={true}
          keyBoardControl={true}
          removeArrowOnDeviceType={["tablet", "mobile"]}
        >
          {props.templePictures.map(
            (item2: any, id: any) => {
              return (
                <img key={id} src={item2.pictureUrl} alt="pictureUrl"></img>
              )

            }
          )}
        </Carousel>
      </Box>
      {props.onboarded?<Badge className="onboardedBadge">{t(LOCALIZATION.ONBOARDED)}</Badge>:null}
      {/* <Badge className="onboardedBadge">Onboarded</Badge> */}
      <Box className="shaktipethaDes">
        <Box className="shaktiDesTop">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>{t(LOCALIZATION.Overview)}</Typography>
            {props.onboarded?<Button onClick={()=>props.onClickNavigateToTemple(props.templeId)}className="visitBtn" variant="contained">Visit</Button>:null}
            
          </Stack>
        </Box>
        <Box className="shortText">
          {/* <Typography>{props.descriptions}</Typography> */}
          <ReadMoreReadLess text={props.descriptions} maxLength={100}></ReadMoreReadLess>
        </Box>
      </Box>

      {/* <Box className="ganpatiBottom">
          <Box className="ratings">
            <i className="bi bi-star-fill"></i>
            <Typography>
              <span>{props.googleData?.rating}</span>{props.googleData?.user_ratings_total}+ ratings
            </Typography>
          </Box>
          <Box className="likeShare">
            <Link to="#">
              <img src={redlike} alt="" />
            </Link>
            <Link to="#">
              <img src={share} alt="" />
            </Link>
          </Box>
        </Box> */}
    </Box>
  )
}